<div class="asset-dropdown" (click)="$event.stopPropagation()" *transloco="let t; prefix: 'assetShared.assetSearch'">
  <label class="dropdown-label">{{ t('label') }} <span class="required">*</span></label>
  <button type="button" class="dropdown-trigger" [class.is-open]="isOpen" (click)="toggle()">
    <span class="dropdown-selected" [class.is-placeholder]="!selectedAssetId || selectedAssetId <= 0">
      {{ selectedAssetId && selectedAssetId > 0 ? selectedLabel : t('selectAsset') }}
    </span>
    <i class="ph ph-caret-down"></i>
  </button>

  @if (isOpen) {
    <div class="asset-dropdown-menu" [style.max-height]="dropdownMaxHeight">
      <div class="dropdown-search" (click)="$event.stopPropagation()">
        <input
          type="text"
          class="dropdown-input search-input"
          [placeholder]="t('searchPlaceholder')"
          [ngModel]="searchTerm"
          (ngModelChange)="onSearchTermChange($event)"
          (click)="$event.stopPropagation()" />
      </div>
      <div class="asset-options-scroll" (scroll)="onMenuScroll($event)">
        @if (isLoading) {
          <div class="dropdown-status">
            <span class="spinner-border spinner-border-sm" [attr.aria-label]="t('loadingAssets')"></span>
          </div>
        } @else {
          @for (asset of assets; track asset.assetId) {
            <div class="asset-option" (click)="selectAsset(asset)">
              <span class="asset-name" [title]="asset.assetName">{{ asset.assetName }}</span>
            </div>
          }
          @if (assets.length === 0) {
            <div class="dropdown-status">{{ t('noAssetsFound') }}</div>
          }
          @if (isLoadingMore) {
            <div class="dropdown-status dropdown-status--loading-more">
              <span class="spinner-border spinner-border-sm" [attr.aria-label]="t('loadingMoreAssets')"></span>
            </div>
          }
        }
      </div>
    </div>
  }

  @if (showRequiredError) {
    <div class="error-message">{{ t('assetRequired') }}</div>
  }
</div>
